module.exports = __webpack_public_path__ + "static/3-b8cf660604c729051e65caf2fd0c047a.jpg";